import {
  EigentuemerPrintOptionsMeta,
  GrundstueckPrintOptionsMeta,
  PrintConfigResponseMeta,
  RechtPrintOptionsMeta
} from "../gb-api";
import {AppAuszugCookieService} from "./app-auszug-cookie-service";

interface PrintConfig {
  getRechtAuszugOptions(): RechtPrintOptionsMeta;

  getGrundstueckAuszugOptions(): GrundstueckPrintOptionsMeta;

  getEigentuemerAuszugOptions(): EigentuemerPrintOptionsMeta;

  updateRechtAuszugOptions(value: RechtPrintOptionsMeta);

  updateGrundstueckAuszugOptions(value: GrundstueckPrintOptionsMeta);

  updateEigentuemerAuszugOptions(value: EigentuemerPrintOptionsMeta);

  reloadRechtDefaultSettings(): RechtPrintOptionsMeta;

  reloadGrundstueckDefaultSettings(): GrundstueckPrintOptionsMeta;

}

export class AppPrintConfig implements PrintConfig {

  pringConfigResponseDefaults: PrintConfigResponseMeta;


  constructor(protected printConfigResponse: PrintConfigResponseMeta) {
    this.pringConfigResponseDefaults = {...this.printConfigResponse};
    this.pringConfigResponseDefaults.grundstueckPrintOptions = {...this.printConfigResponse.grundstueckPrintOptions};
    this.pringConfigResponseDefaults.rechtPrintOptions = {...this.printConfigResponse.rechtPrintOptions};
    this.pringConfigResponseDefaults.eigentuemerPrintOptions = {...this.printConfigResponse.eigentuemerPrintOptions};
  }

  getRechtAuszugOptions(): RechtPrintOptionsMeta {
    return {...this.printConfigResponse.rechtPrintOptions};
  }

  getGrundstueckAuszugOptions(): GrundstueckPrintOptionsMeta {
    return {...this.printConfigResponse.grundstueckPrintOptions};
  }

  getEigentuemerAuszugOptions(): EigentuemerPrintOptionsMeta {
    return {...this.printConfigResponse.eigentuemerPrintOptions};
  }

  updateRechtAuszugOptions(value: RechtPrintOptionsMeta) {
    this.printConfigResponse.rechtPrintOptions = value;
  }

  updateGrundstueckAuszugOptions(value: GrundstueckPrintOptionsMeta) {
    this.printConfigResponse.grundstueckPrintOptions = value;
  }

  updateEigentuemerAuszugOptions(value: EigentuemerPrintOptionsMeta) {
    this.printConfigResponse.eigentuemerPrintOptions = value;
  }

  reloadRechtDefaultSettings(): RechtPrintOptionsMeta {
    this.updateRechtAuszugOptions({...this.pringConfigResponseDefaults.rechtPrintOptions});
    return this.getRechtAuszugOptions();
  }

  reloadGrundstueckDefaultSettings(): GrundstueckPrintOptionsMeta {
    this.updateGrundstueckAuszugOptions({...this.pringConfigResponseDefaults.grundstueckPrintOptions});
    return this.getGrundstueckAuszugOptions();
  }
}

export class CookiePrintConfig extends AppPrintConfig {

  constructor(printConfigResponse: PrintConfigResponseMeta, private printCookieSettingService: AppAuszugCookieService) {
    super(printConfigResponse);
    this.printCookieSettingService.saveRechtCookies(this.printConfigResponse.rechtPrintOptions, true);
    this.printCookieSettingService.saveGrundstueckCookies(this.printConfigResponse.grundstueckPrintOptions, true);
    this.printCookieSettingService.saveEigentuemerCookies(this.printConfigResponse.eigentuemerPrintOptions, true);
  }

  updateRechtAuszugOptions(value: RechtPrintOptionsMeta) {
    super.updateRechtAuszugOptions(value);
    this.printCookieSettingService.saveRechtCookies(value);
  }

  updateGrundstueckAuszugOptions(value: GrundstueckPrintOptionsMeta) {
    super.updateGrundstueckAuszugOptions(value);
    this.printCookieSettingService.saveGrundstueckCookies(value);
  }

  updateEigentuemerAuszugOptions(value: EigentuemerPrintOptionsMeta) {
    super.updateEigentuemerAuszugOptions(value);
    this.printCookieSettingService.saveEigentuemerCookies(value);
  }

  getGrundstueckAuszugOptions(): GrundstueckPrintOptionsMeta {
    return this.printCookieSettingService.readGrundstueckCookies(this.printConfigResponse.grundstueckPrintOptions);
  }

  reloadGrundstueckDefaultSettings(): GrundstueckPrintOptionsMeta {
    this.updateGrundstueckAuszugOptions({...this.pringConfigResponseDefaults.grundstueckPrintOptions});
    return this.getGrundstueckAuszugOptions();
  }

  getEigentuemerAuszugOptions(): EigentuemerPrintOptionsMeta {
    return this.printCookieSettingService.readEigentuemerCookies(this.printConfigResponse.eigentuemerPrintOptions);
  }

  getRechtAuszugOptions(): RechtPrintOptionsMeta {
    return this.printCookieSettingService.readRechtCookies(this.printConfigResponse.rechtPrintOptions);
  }

  reloadRechtDefaultSettings(): EigentuemerPrintOptionsMeta {
    this.updateRechtAuszugOptions({...this.pringConfigResponseDefaults.rechtPrintOptions});
    return this.getRechtAuszugOptions();
  }
}
